<!--
2022-09-22 Matt Promotion规则，读取静态文件内容
-->
<template>
  <div class="promotion-game-rule-container">
    <div class="top-back">
      <TopBack :title="$t('lang.promotion.rules')" :handelBack="gotoPromotion"/>
    </div>
    <div class="promotionRulePage" id="promotionRulePage">
      <div class="topContainer">
        <img
          class="introduceImg"
          :alt="promotion.name"
          :src="promotion.introduceImg"
          :key="promotion.name"
        >
        <div class="ruleBox" ref="ruleBox">
          <div class="rules" v-html="ruleHtml"/>
        </div>
        <div class="scrollbar-track" ref="scrollbarTrack" v-show="scrollShow">
          <div class="scrollbar-thumb" ref="scrollbarThumb"></div>
        </div>
      </div>
      <div class="gameContainer">
        <div class="title">
          <div class="img"><img :src="clap"/></div>
          <div class="text">
            {{ 'Participating games （' + gameList.length + '）' }}
          </div>
        </div>
        <Loadmore
          :bottomPullText="''"
          :bottomDropText="''"
          :bottomLoadingText="''"
          :auto-fill="false"
          :bottom-method="() => {
                loadMoreGames()
          }"
          :bottom-all-loaded="hasLoadAll"
          ref="loadmore">
          <div class="gameList">
            <div class="game" v-for="(game,index) in gameShowList" :key="index" @click="fetchGame(game)">
              <div class="game-image-mask" v-bind:style="{backgroundImage:'url(' + logo5 + ')'}"/>
              <div class="game-image-wrapper" v-bind:style="{backgroundImage:'url('+game.ThumbnailUrl+')'}"/>
              <div class="game-name">
                <span>{{ game.GameNameEn }}</span>
              </div>
            </div>
            <div class="more" v-if="!hasLoadAll" @click="loadMoreGames">
              <div>{{$t('lang.common.viewMore')}}</div>
              <img :src="more"/>
            </div>
          </div>
        </Loadmore>
      </div>
      <div class="top"><img :src="toTop" v-if="!isTop" @click="goToTop"/></div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import TopBack from '@/components/TopBack/index'
import toTop from '@/assets/images/promotion/toTop.svg'
import clap from '@/assets/images/promotion/clap.svg'
import more from '@/assets/images/promotion/more.svg'
import logo5 from '@/assets/images/common/logo5.png'
import config from '../../../static/config/config'
import {Loadmore, Toast} from 'mint-ui'
import store from '@/store/store'

export default {
  name: 'PromotionGame',
  components: {
    Loadmore,
    TopBack
  },
  data () {
    return {
      clap,
      more,
      logo5,
      toTop,
      isTop: true,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      promotion: {},
      pageSize: 10,
      scrollShow: false,
      showGame: false,
      playGame: false,
      gameList: [],
      gameShowList: [],
      hasLoadAll: true,
      ruleHtml: ''
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.loadData()
    },
    'showGame': function (n) {
      store.commit('setUserOnGame', n)
    }
  },
  mounted () {
    if (!this.userInfo) {
      this.$router.push('/Login')
      return
    }
    window.addEventListener('scroll', this.handleScroll, true)
    this.initGames()
    this.loadData()
    this.initScrollbar()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goToTop () {
      document.querySelector('#promotionRulePage').scrollTop = 0
    },
    handleScroll: function () {
      if (document.querySelector('#promotionRulePage')) {
        let scrollTop = document.querySelector('#promotionRulePage').scrollTop
        if (scrollTop < 1) {
          this.isTop = true
        } else {
          this.isTop = false
        }
      }
    },
    loadData: function () {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      if (!this.userInfo) {
        cid = null
      }
      const url = 'innovation/home/promotion/get/one'
      let param = 'local=' + (localStorage.getItem('locale') || 'EN') + '&client=app&campaignId=' + cid + '&key=' + this.$route.query.key
      let fullUrl = url + '?' + param
      request('get', fullUrl).then(res => {
        let item = res.Result
        this.promotion = {
          ...item,
          startUpPopup: item.SequenceNo,
          name: item.Name,
          category: item.Category.split(','),
          key: item.KeyText,
          path: item.Url,
          type: item.PromotionType,
          introduceImg: item.Cover
        }
        this.ruleHtml = this.promotion.Content
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * 做一个假的滚动条实现设计效果 YTW.20240117
     */
    initScrollbar () {
      const ruleBox = this.$refs.ruleBox
      const scrollbarThumb = this.$refs.scrollbarThumb

      ruleBox.addEventListener('scroll', () => {
        this.scrollShow = true
        const scrollTop = ruleBox.scrollTop
        const scrollHeight = ruleBox.scrollHeight
        const clientHeight = ruleBox.clientHeight

        const thumbHeight = Math.max(clientHeight / scrollHeight * clientHeight, 20)
        const thumbTop = scrollTop / (scrollHeight - clientHeight) * (clientHeight - thumbHeight)

        scrollbarThumb.style.height = `${thumbHeight}px`
        scrollbarThumb.style.transform = `translateY(${thumbTop}px)`
      })
    },
    /**
     * 获取该活动下的游戏列表
     */
    initGames () {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      if (!this.userInfo) {
        cid = null
      }
      const url = '/innovation/home/get/promotions_games'
      let param = 'local=' + (localStorage.getItem('locale') || 'EN') + '&client=app&campaignId=' + cid + '&promotionId=' + this.$route.query.id
      let fullUrl = url + '?' + param
      request('get', fullUrl).then(res => {
        if (res && res.Games) {
          this.gameList = res.Games
          if (this.gameList.length <= this.pageSize) {
            this.gameShowList = this.gameList
            this.hasLoadAll = true
          } else {
            this.gameShowList = this.gameList.slice(0, this.pageSize)
            this.hasLoadAll = false
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * 下拉加载更多游戏
     */
    loadMoreGames () {
      if ((this.gameShowList.length + this.pageSize) * 1 >= this.gameList.length) {
        this.gameShowList = this.gameList
        this.hasLoadAll = true
      } else {
        this.gameShowList = this.gameList.slice(0, (this.gameShowList.length + this.pageSize) * 1)
        this.hasLoadAll = false
      }
    },
    /****
     * 记录用户玩过的游戏到本地
     * */
    recordPlayedGame (game) {
      let storage = localStorage.getItem('PlayHistory')
      let histories = JSON.parse(storage)
      if (histories === null) {
        histories = []
      }
      var playedGame = {
        GameCode: game.GameCode,
        GameCategory: this.showType,
        PlayTime: new Date()
      }

      const len = histories.length
      if (len > 0) {
        let found = histories.find(item => item.GameCode === playedGame.GameCode && item.GameCategory === playedGame.GameCategory)
        if (found) {
          found.PlayTime = new Date()
        } else {
          var indx = histories.findIndex(f => f.GameCategory === playedGame.GameCategory)
          if (indx >= 0) { // 只有找到同类的游戏时
            histories.splice(indx, 1) // 删除玩过的同类游戏，这样只记录用户最新玩过的游戏
          }
          histories.push(playedGame)
        }
      } else {
        histories.push(playedGame)
      }
      localStorage.setItem('PlayHistory', JSON.stringify(histories))
    },
    gotoPromotion () {
      this.$router.push('/Promotion')
    },
    fetchGame (game) { // 原来的fetchGame
      if (this.userInfo) {
        if (this.$store.state.banUserId.includes(this.userInfo.UserId)) {
          Toast(this.$t('lang.home.gameMaintenancePrompt'))
          return
        }
        this.recordPlayedGame(game) // 记录用户玩过的游戏
        const url = '/innovation/game/getgameurl'
        const data = {
          userId: this.userInfo.UserId || '',
          gameCode: game.GameCode,
          gameProviderId: game.GameProviderId,
          deviceWidth: document.body.clientWidth,
          lang: localStorage.getItem('locale'),
          internation: this.$store.state.internation,
          campaignId: localStorage.getItem('cid'),
          localVersion: config.version,
          localApkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0'
        }
        request('post', url, data).then(res => {
          if (res.Url) {
            const gameInfo = {
              gameUrl: res.Url,
              gameImg: game.ThumbnailUrl,
              gameName: game.GameNameEn
            }
            this.$store.commit('setShowGame', true)
            this.$store.commit('setGameInfo', gameInfo)
          } else {
            Toast(this.$t('lang.home.gameMaintenancePrompt'))
          }
        }).catch(() => {
          Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
        })
      } else {
        this.$router.push('/Login')
      }
    },
    confirmGotoPage () {
      this.$router.push('/Deposit')
    },
    close () {
      this.showGame = false
    }
  }
}
</script>

<style lang="less" scoped>
.promotion-game-rule-container {
    padding:56px 0 0 0;
    background-color: rgba(0,0,0,.9);
    height: calc(100vh - 70px);
    display: flex;
    flex-direction: column;
  .top-back {
    top: 0;
  }
  .promotionRulePage {
    flex: 1;
    overflow-x: hidden;
    overflow-y: scroll;
    text-align: center;

    .topContainer{
      position: relative;
      top: 2.7vw;
      left: 50%;
      transform: translate(-50%);
      width: 94.444vw;
      height: 113.888vw;
      overflow: hidden;
      border-radius: 4.12vw;
      border: 0.7vw solid #F6D9AA;
      background-color: #191C1A;
    }

    .gameContainer {
      position: relative;
      top: 5vw;
      left: 50%;
      transform: translate(-50%);
      width: 94.444vw;
      height: max-content;

      .title {
        width: 96%;
        margin: 0 auto 2vw;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .img {
          height: 4.722vw;

          img {
            height: 100%
          }
        }

        .text {
          margin-left: 3vw;
          margin-top: 1vw;
          font-size: 4.722vw;
          font-weight: 700;
          letter-spacing: 0;
          text-align: left;
          color: #FFFFFF;
        }
      }

      .gameList {
        position: relative;
        top: 0;
        width: 100%;
        height: max-content;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        padding: 1vw;

        .game {
          position: relative;
          display: block;
          width: 43.988vw;
          height: max-content;
          margin-bottom: 0.5vw;

          .game-image-mask {
            position: absolute;
            width: 100%;
            height: 20vw;
            background-repeat: no-repeat;
            background-position: bottom;
            background-size: 50%;
            z-index: 1;
          }
          .game-image-wrapper {
            position: relative;
            width: 100%;
            height: 24.691vw;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            border-radius: 1.944vw;
            z-index: 2;
          }
          .game-name{
            width: 100%;
            height: 8vw;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
              font-size: 3.888vw;
              font-weight: 400;
              color: #CFCFCF;
            }
          }
        }

        .more{
          margin: 1vw auto 2vw auto;
          width: 36.111vw;
          height: 10vw;
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          background-color: #111111;
          font-size: 4.444vw;
          font-weight: 700;
          color: #F6D9AA;
        }
      }
    }
    .ruleBox{
      position: relative;
      top: 1.5vw;
      left: 50%;
      transform: translate(-50%);
      width: 92%;
      height: 62vw;
      overflow-x: hidden;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }

    .ruleBox::-webkit-scrollbar {
      display: none; /* 隐藏原生滚动条 */
    }
    .ruleBox:hover .scrollbar-track {
      opacity: 1;
    }

    .introduceImg {
      width: 100%;
      height: 46.258vw;
      border-radius: calc(4.12vw - 2px) calc(4.12vw - 2px) 0 0;
    }
    .rules {
      height: max-content;
      width: 100%;
      text-align: left;
      display: flex;
      flex-direction: column;
      table{
        flex-shrink: 0.1;
        width: 100% !important;
      }
    }

    .scrollbar-track {
      position: absolute;
      bottom: 3vw;
      right: 2vw;
      width: 1.33vw;
      height: 62vw;
      border-radius: 0.8vw;
      background-color: #000000;
      opacity: 1;
      z-index: 1;
    }

    .scrollbar-thumb {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      border-radius: 0.8vw;
      background-color: #474B47; /* 滚动条颜色 */
    }

    .top {
      position: fixed;
      right: 3.3vw;
      bottom: calc(1vh + 70px);
      width: 10.277vw;
      z-index: 3;
      img{
        width: 100%;
      }
    }

    /deep/ .mint-loadmore-bottom {
      display: none;
    }

    /deep/ .mint-loadmore-content {
      margin-bottom: 0;
    }

    /deep/ .is-dropped {
      transform: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Promotion/gameRule.vue